export const global_height_breakpoint_sm = {
  "name": "--pf-v5-global--height-breakpoint--sm",
  "value": "0",
  "var": "var(--pf-v5-global--height-breakpoint--sm)"
};
export default global_height_breakpoint_sm;